import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import IdentityCardForm from './form';
import {
  NewPersonVM,
  AccordionIdentityCard,
} from 'shell/components/shared/sipo-person-form/new-person';

const IdentityCardComponent = (): React.ReactElement => {
  const [open, setOpen] = useState(false);

  const formContext = useFormikContext<NewPersonVM>();

  const onFieldIdentityCardChange = useEventCallback(
    (
      key: keyof AccordionIdentityCard,
      value: AccordionIdentityCard[keyof AccordionIdentityCard]
    ) => {
      formContext.setFieldValue('identityCard', {
        ...formContext.values.identityCard,
        [key]: value,
      });
    }
  );

  const onFieldsIdentityCardChange = useEventCallback((vals: AccordionIdentityCard) => {
    formContext.setFieldValue('identityCard', {
      ...formContext.values.identityCard,
      ...vals,
    });
  });

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-id-card-content"
        id="panel-person-id-card-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Carta d&apos;identità</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <IdentityCardForm
          values={formContext.values.identityCard}
          onChange={onFieldIdentityCardChange}
          onChangeValues={onFieldsIdentityCardChange}
          errors={formContext.errors.identityCard as FormikErrors<AccordionIdentityCard>}
          touched={
            formContext.touched.identityCard as unknown as FormikTouched<AccordionIdentityCard>
          }
        />
      </AccordionDetails>
    </Accordion>
  );
};

IdentityCardComponent.displayName = 'Accordion Identity Card component';

const IdentityCard = memo(IdentityCardComponent);

export default IdentityCard;
